import { tsUtils } from '@neo-one/ts-utils';
export const hasBuffer = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isBuffer(context, node, tpe));
export const isOnlyBuffer = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isBuffer(context, node, tpe));
export const isBuffer = (context, node, type) => context.builtins.isInterface(node, type, 'Buffer') ||
    context.builtins.isInterface(node, type, 'Hash256') ||
    context.builtins.isInterface(node, type, 'PublicKey') ||
    context.builtins.isInterface(node, type, 'Address');
export const isAddress = (context, node, type) => context.builtins.isInterface(node, type, 'Address');
export const isHash256 = (context, node, type) => context.builtins.isInterface(node, type, 'Hash256');
export const isPublicKey = (context, node, type) => context.builtins.isInterface(node, type, 'PublicKey');

//# sourceMappingURL=typeTests.js.map
